// Styles
import './framed-slider.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initframedSlider = (context) => {
  const framedSliderSection = context.closest('.shopify-section');

  if (framedSliderSection) {
    const slidesContainer = framedSliderSection.querySelector('.framed-slider__wrapper');
    const slides = slidesContainer.querySelectorAll('.swiper-wrapper .framed-slider__slide');
    const slidesCount = slides.length;

    slides.forEach(slide => {
      slide.addEventListener('click', () => {
        if (slide.dataset.slideRedirect) {
          location.href = slide.dataset.slideRedirect;
        }
      });
    });

    if (slidesCount > 1) {
      const swiper = new Swiper(framedSliderSection.querySelector('.framed-slider__wrapper'), {
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          prevEl: framedSliderSection.querySelector('.framed-slider__arrows__arrow.left'),
          nextEl: framedSliderSection.querySelector('.framed-slider__arrows__arrow.right'),
        },
      });
    }
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.framed-slider__wrapper'), (el) => {
    window.dAgency.initframedSlider(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.framed-slider__wrapper'), (el) => {
      window.dAgency.initframedSlider(el);
    });
  });
}
